import sanat from '../assets/sanatan.jpg'
import mayur from '../assets/Mayur.jpg'
import sandeep from '../assets/sandeep.jpg'
import biswa from '../assets/biswa.png'

const foundersData = [
  {
    "id": 1,
    "name": "Sanat Behera",
    "por": "Founder & CEO — Vision and Strategy",
    "description": "Started Clinqo to solve the problems of India and is passionate about new technologies and implementation of technologies to solve real life problems. With his roots belonging to a humble background, he is passionate to build things to scale and believes in customer obsession.",
    "email": "",
    "src": sanat,
  },
  {
    "id": 2,
    "name": "Mayur Pachpor",
    "por": "Co-Founder & CTO — Tech and Innovation",
    "description": "Sharing the same vision and interest, our OG tech guy comes from a versatile background of technologies and is focused on deployments of solutions that are hard to solve and implement. He is in pursuit of the best people and brings the philosophy of achieving the unachievable to the organisation.",
    "email": "",
    "src": mayur,
  },
  {
    "id": 3,
    "name": "Sandeep Kumar Das",
    "por": "Co-Founder & CXO — Operations and Growth",
    "description": "Starting as an engineering person, our dearest team member always understands phenomena from roots and brings in the sense of first principle thinking and logical reasoning to achieve targets. From handling internal to external operations, he believes excellence at each step brings excellence at macro levels.",
    "email": "",
    "src": sandeep,
  },
  {
    "id": 4,
    "name": "Biswaranjan Dash",
    "por": "Tech Lead — Explorer of Ideas",
    "description": "The one who loves to tinker, explore new tech, and isn’t afraid to break things to learn faster. Our future Tech Lead will bring curiosity, energy, and the drive to build cool stuff that actually works at scale while inspiring the team to push boundaries every day.",
    "email": "",
    "src": biswa,
  }
]
export default foundersData
